export const environment = {
  production: true,
  company: 'abc_release',
  APIUrl: 'https://abc.backend.jbmsoftware.nl/',
  SocketIO_EndPoint: 'https://abc.backend.jbmsoftware.nl',
  RecipeAppSupport:true
};
